import { render, staticRenderFns } from "./VolunteerCausesDialog.vue?vue&type=template&id=25a994fa&scoped=true"
import script from "./VolunteerCausesDialog.vue?vue&type=script&lang=js"
export * from "./VolunteerCausesDialog.vue?vue&type=script&lang=js"
import style0 from "./VolunteerCausesDialog.vue?vue&type=style&index=0&id=25a994fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a994fa",
  null
  
)

export default component.exports